module.exports = __webpack_public_path__ + "media/escudos/logo_muni_maranon-84db34bc.png";